export const chineseLiterature =[
	  {
	    "name": "大众对 XXX 作家作品的接受现状、阅读偏好及传播推广策略调研",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "网络文学读者阅读行为、付费意愿及内容创作引导策略分析",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "当代通俗文学受众群体特征与审美取向实证调研",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "校园文学创作现状、发展困境及扶持策略研究",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "经典现当代文学作品大众阅读率偏低成因及推广对策",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "短视频文学解读内容受众满意度及创作优化策略调研",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "青年群体文学阅读习惯、媒介选择及阅读引导策略分析",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "地域文学作品认知度、传播现状及活化发展策略调研",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "文学改编影视的观众评价、接受差异及创作适配策略",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "实体文学书店客流现状、读者需求及经营转型策略实证",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "当代散文受众审美偏好及创作风格发展趋势调研分析",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "科幻文学读者群体特征、阅读动机及市场发展策略",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "女性文学作品大众认知现状与传播路径优化策略调研",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "公共图书馆文学类图书借阅情况及馆藏优化策略分析",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "民国文学作品当代接受度及普及传播策略实证研究",
	    "desc": "现当代文学与大众文学研究",
	    "path": " "
	  },
	  {
	    "name": "大众古典诗词诵读、学习现状及普及推广策略调研分析",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "青少年古典名著阅读情况、阅读障碍及引导策略研究",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "传统戏曲文本受众认知现状、接受意愿及传承发展策略",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "国学经典学习需求、参与动机及课程优化策略实证调研",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "地方古籍文献知晓度、保护现状及活化利用策略分析",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "古典小说当代传播形式受众评价及创新推广策略调研",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "不同群体对传统楹联、灯谜等民俗文学的认知度调研",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "古风文学创作爱好者群体特征、创作现状及发展策略",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "古诗文背诵学习效果评价及教学方法优化策略研究",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "传统家训文化当代认知度、认同度及传播应用策略",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "文人笔记类古籍大众接受现状及通俗化改编策略调研",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "古典文论知识普及现状及大众科普传播策略分析",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "非遗口头文学（民间故事、歌谣）传承现状及保护策略",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "古代辞赋作品当代传播困境及创新推广路径实证调研",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "传统节令诗词认知情况及文旅融合传播发展策略",
	    "desc": "古代文学、古典文献与传统文化",
	    "path": " "
	  },
	  {
	    "name": "青少年网络用语使用现状、认知态度及语言规范引导策略",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "方言使用现状、传承意愿及保护推广策略实证调研",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "城市公共场所语言文字规范使用情况调查及整治策略",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "大学生口语表达能力现状、问题及提升训练策略分析",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "职场书面语运用现状、常见问题及规范优化策略调研",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "谐音梗、创意广告语语言使用评价及创作规范研究",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "中老年群体智能手机文字输入、阅读使用障碍及优化策略",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "校园语言环境现状、文明用语使用情况及引导策略调研",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "外来词在汉语中的使用现状、大众接受度及规范策略",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "公众普通话水平现状、学习需求及普及提升策略分析",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "短视频字幕语言使用乱象及规范管理策略实证调研",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "地方特色方言词汇认知度、使用场景及留存保护策略",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "公文写作常见语言问题成因及写作能力提升策略调研",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "亲子沟通语言表达现状、问题及沟通优化策略分析",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "公共标识语翻译、用词错误现状及整改优化策略调研",
	    "desc": "语言学、汉语应用与社会语言",
	    "path": " "
	  },
	  {
	    "name": "中小学生语文学习兴趣现状、影响因素及激发策略调研",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "语文课堂阅读教学效果评价及教学模式优化策略分析",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "中学生作文写作现状、难点及写作教学改进策略实证",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "语文课外阅读开展情况、存在问题及家校协同引导策略",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "教师古诗文教学方法使用现状及教学效果提升策略调研",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "双减背景下语文课后服务开展现状及课程优化策略分析",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "高中生整本书阅读实施现状、困境及推进策略实证调研",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "小学语文识字教学现状、方法对比及优化提升策略",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "语文课堂互动效果学生评价及课堂组织策略调研分析",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "中学生文言文学习难点、畏难情绪及教学疏导策略",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "家校沟通中语文学习指导现状及协同教育策略调研",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "中职院校语文课程满意度及课程内容改革发展策略",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "朗诵教学开展现状、学习效果及普及推广策略分析",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "语文作业设计现状、学生负担评价及优化设计策略",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "师范生语文教学技能现状、短板及实训提升策略调研",
	    "desc": "语文教育与课堂教学",
	    "path": " "
	  },
	  {
	    "name": "微信公众号文学类推文阅读体验、传播效果及创作策略",
	    "desc": "新媒体文学、影视文案与传播",
	    "path": " "
	  },
	  {
	    "name": "影视台词语言风格观众评价及文案创作优化策略调研",
	    "desc": "新媒体文学、影视文案与传播",
	    "path": " "
	  },
	  {
	    "name": "自媒体文案写作现状、流量逻辑及内容提质发展策略",
	    "desc": "新媒体文学、影视文案与传播",
	    "path": " "
	  },
	  {
	    "name": "朋友圈、社交平台个人文案使用偏好及语言特征分析",
	    "desc": "新媒体文学、影视文案与传播",
	    "path": " "
	  },
	  {
	    "name": "有声书文本改编现状、听众评价及改编优化策略调研",
	    "desc": "新媒体文学、影视文案与传播",
	    "path": " "
	  },
	  {
	    "name": "文旅宣传文案创作现状、传播效果及风格优化策略",
	    "desc": "新媒体文学、影视文案与传播",
	    "path": " "
	  },
	  {
	    "name": "直播文案、口播语言运用现状及表达提升策略实证调研",
	    "desc": "新媒体文学、影视文案与传播",
	    "path": " "
	  },
	  {
	    "name": "动漫、游戏文学脚本受众评价及创作改进策略分析",
	    "desc": "新媒体文学、影视文案与传播",
	    "path": " "
	  },
	  {
	    "name": "短视频文案爆款要素分析及内容创作运营策略调研",
	    "desc": "新媒体文学、影视文案与传播",
	    "path": " "
	  },
	  {
	    "name": "社交媒体文学话题传播规律及引导管理策略研究",
	    "desc": "新媒体文学、影视文案与传播",
	    "path": " "
	  },
	  {
	    "name": "大众日常写作能力现状、短板及全民写作素养提升策略",
	    "desc": "写作应用、文化服务与文创文案",
	    "path": " "
	  },
	  {
	    "name": "景区文创产品文案设计评价及创意优化策略实证调研",
	    "desc": "写作应用、文化服务与文创文案",
	    "path": " "
	  },
	  {
	    "name": "企业宣传文案使用现状、传播效果及创作升级策略分析",
	    "desc": "写作应用、文化服务与文创文案",
	    "path": " "
	  },
	  {
	    "name": "民间故事改编文创文本现状、受众接受度及优化策略",
	    "desc": "写作应用、文化服务与文创文案",
	    "path": " "
	  },
	  {
	    "name": "应用文写作普及现状、社会需求及教学推广策略调研",
	    "desc": "写作应用、文化服务与文创文案",
	    "path": " "
	  },
	  {
	    "name": "社区文化宣传栏文案现状、传播效果及内容优化策略",
	    "desc": "写作应用、文化服务与文创文案",
	    "path": " "
	  },
	  {
	    "name": "节日主题文案创作偏好、使用场景及创意发展策略调研",
	    "desc": "写作应用、文化服务与文创文案",
	    "path": " "
	  },
	  {
	    "name": "博物馆解说词文本评价及语言风格优化改进策略分析",
	    "desc": "写作应用、文化服务与文创文案",
	    "path": " "
	  },
	  {
	    "name": "自媒体书评、影评写作现状、行业问题及规范发展策略",
	    "desc": "写作应用、文化服务与文创文案",
	    "path": " "
	  },
	  {
	    "name": "地方文化宣传文本现状、传播短板及创作提升策略调研",
	    "desc": "写作应用、文化服务与文创文案",
	    "path": " "
	  },
	  {
	    "name": "陶渊明田园诗艺术与价值探析",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "王维山水诗手法及后世影响",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "李白诗歌浪漫特色与当代启示",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "杜甫诗作现实主义特质研究",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "柳宗元游记艺术与传承价值",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "苏轼词作风格及现代借鉴",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "《西厢记》艺术成就与影响",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "《红楼梦》人物塑造手法探析",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "唐宋婉约词艺术与审美传承",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "先秦诸子散文论辩艺术研究",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "龚自珍诗歌艺术与思想内涵",
	    "desc": "近代文学",
	    "path": " "
	  },
	  {
	    "name": "梁启超诗界革命创作探析",
	    "desc": "近代文学",
	    "path": " "
	  },
	  {
	    "name": "晚清谴责小说讽刺艺术研究",
	    "desc": "近代文学",
	    "path": " "
	  },
	  {
	    "name": "《人间词话》理论与当代借鉴",
	    "desc": "近代文学",
	    "path": " "
	  },
	  {
	    "name": "秋瑾诗文抒情特色解读",
	    "desc": "近代文学",
	    "path": " "
	  },
	  {
	    "name": "鲁迅小说讽刺艺术及现实意义",
	    "desc": "现当代文学",
	    "path": " "
	  },
	  {
	    "name": "朱自清散文语言艺术探析",
	    "desc": "现当代文学",
	    "path": " "
	  },
	  {
	    "name": "老舍小说叙事手法与特色",
	    "desc": "现当代文学",
	    "path": " "
	  },
	  {
	    "name": "茅盾现实主义创作手法研究",
	    "desc": "现当代文学",
	    "path": " "
	  },
	  {
	    "name": "汪曾祺散文笔法与创作启示",
	    "desc": "现当代文学",
	    "path": " "
	  },
	  {
	    "name": "孟浩然山水诗艺术与影响",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "李贺诗歌奇幻手法探析",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "柳永词作风格及当代借鉴",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "《牡丹亭》艺术特色与传承",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "魏晋咏怀诗创作手法研究",
	    "desc": "古代文学",
	    "path": " "
	  },
	  {
	    "name": "林纾译作艺术特色解读",
	    "desc": "近代文学",
	    "path": " "
	  },
	  {
	    "name": "苏曼殊诗文抒情手法探析",
	    "desc": "近代文学",
	    "path": " "
	  },
	  {
	    "name": "冰心散文语言艺术与启示",
	    "desc": "现当代文学",
	    "path": " "
	  },
	  {
	    "name": "沈从文小说乡土笔法研究",
	    "desc": "现当代文学",
	    "path": " "
	  },
	  {
	    "name": "钱钟书小说幽默艺术探析",
	    "desc": "现当代文学",
	    "path": " "
	  }
]